export var SDK_VERSION = '6.19.6';
//# sourceMappingURL=version.js.map